import { render, staticRenderFns } from "./show-education.vue?vue&type=template&id=6d3e2752&scoped=true&"
import script from "./show-education.vue?vue&type=script&lang=js&"
export * from "./show-education.vue?vue&type=script&lang=js&"
import style0 from "./show-education.vue?vue&type=style&index=0&id=6d3e2752&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3e2752",
  null
  
)

export default component.exports